import React from 'react';
import { Tooltip } from '@material-ui/core';
import { Info } from '@material-ui/icons';

import { dateTimeCell } from '../../components/Grid/Cells/DateTimeCell';
import DateFilter from '../../components/Grid/Filter/Date';
import BooleanView from '../../components/DataGrid/ValueViews/BooleanView';

const columnConfig = t => [
  {
    title: 'addressRequest.requestedAt',
    accessor: row => dateTimeCell(row.requestedAt, true),
    name: 'requestedAt',
    Filter: ({ onChange, filter }) => (
      <DateFilter onChange={onChange} value={filter?.value} />
    ),
  },
  {
    title: 'addressRequest.address.postCode',
    accessor: 'address.postCode',
    name: 'address.postCode',
  },
  {
    title: 'addressRequest.address.city',
    accessor: 'address.city',
    name: 'address.city',
  },
  {
    title: 'addressRequest.address.street',
    accessor: 'address.street',
    name: 'address.street',
  },
  {
    title: 'addressRequest.address.building',
    accessor: 'address.building',
    name: 'address.building',
  },
  {
    title: 'addressRequest.email',
    accessor: 'email',
    name: 'email',
  },
  {
    Header: (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {t('addressRequest.isNotified', 'Powiadomiono')}
        <Tooltip title={t('addressRequest.isNotifiedTooltip')} placement="top">
          <Info style={{ fontSize: '14px', marginLeft: '4px' }} />
        </Tooltip>
      </div>
    ),
    accessor: row => <BooleanView value={row.notifiedAt !== null} />,
    name: 'notifiedAt',
    width: 75,
    filterable: false,
    sortable: false,
  },
];

export default columnConfig;
